<template>
  <div>
    <header>
      <p>二级页面</p>
    </header>
    <div class="body">
      <div class="wrapper">
        <div class="nav">
          <a-menu :selected-keys="selectedKey" mode="inline">
            <a-menu-item
              @click="handlerClickMenu(e.path)"
              :key="e.path"
              v-for="(e,i) in routesList"
            >{{ e.meta.title }}</a-menu-item>
          </a-menu>
        </div>
      </div>

      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routesList: [],
      selectedKey: [],
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.getKey()
        this.getRouterName()
      },
      immediate: true
    }
  },
  methods: {
    //获取三级栏目
    getRouterName() {
      let routes = this.$router.options.routes;
      if(this.$route.path.split('/').length > 4){
        let matched = routes.filter(item => this.$route.path.indexOf(item.path) == 0)
        matched = matched[0].children.filter(item => this.$route.path.indexOf(item.path) > 0)
        matched = matched[0].children.filter(item => this.$route.path.indexOf(item.path) > 0)
        this.routesList = matched[0].children;
      }
      
    },
    //获取选中key
    getKey() {
      this.selectedKey = [this.$route.path.split('/').pop()]
    },

    handlerClickMenu(path) {
      let routePath
      if(this.$route.path.split('/').length == 4){
        routePath = this.$route.path
      }else if(this.$route.path.split('/').length == 5){
        let routeArr = this.$route.path.split('/')
        routeArr.pop()
        routeArr = routeArr.join("/")
        routePath = routeArr
      }
      this.$router.push({
        path: routePath + '/' + path
      }).catch(e => { })
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  height: 40px;
  width: 100%;
  p {
    font-size: $sixteen-PX;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
}
.body {
  width: 100%;
  min-height: 800px;
  background: white;
  .wrapper {
    width: 140px;
    min-height: 800px;
    border-right: 1px solid #e9e9e9;
    float: left;
    
    .nav {
      padding-top: 30px;
      position: sticky;
      top: 50px;
      /deep/ .ant-menu-inline {
        border: none;
        .ant-menu-item-selected {
          background-color: $four-level-bj-color;
          color: $four-choose-font-color;
          &::after {
            border-right: 3px solid $choose-color;
          }
        }

        .ant-menu-item {
          color: $four-font-color;
        }
      }
    }
  }
  .content {
    width: calc(100% - 140px);
    min-height: 800px;
    float: left;
    padding: $sixteen-PX;
    box-sizing: border-box;
  }
}
</style>